import * as themes from '@stepstone-genesis/dresscode';
import { Site } from '@stepstone/brand-helpers';
const brands = {
    [Site.CWJobs]: 'cwjobs',
    [Site.Totaljobs]: 'core',
    [Site.Jobsite]: 'jobsite',
    [Site.Milkround]: 'milkround',
    [Site.Caterer]: 'caterer',
    [Site.CityJobs]: 'cityjobs',
    [Site.JustEngineers]: 'justengineers',
    [Site.EmedCareers]: 'emedcareers',
    [Site.RetailChoice]: 'retailchoice',
    [Site.CatererGlobal]: 'catererglobal',
    [Site.CareerStructure]: 'careerstructure',
    [Site.StepStoneDE]: 'coretwentyfive',
    [Site.StepStoneAT]: 'core',
    [Site.StepStoneBE]: 'core',
    [Site.StepStoneNL]: 'core',
    [Site.Pnet]: 'core',
    [Site.NIJobs]: 'core',
    [Site.IrishJobs]: 'core',
    [Site.Jobsie]: 'jobsie',
};
export const getTheme = (siteId) => {
    try {
        const brandKey = brands[siteId];
        const theme = themes[brandKey];
        if (typeof theme === 'undefined') {
            throw new Error();
        }
        return theme;
    }
    catch (e) {
        throw new Error(`No theme found for site name: '${Site[siteId]}'.`);
    }
};
